import React from 'react'
import { FormattedMessage } from 'react-intl'

export const defaultTableCell = ({ getValue }) => getValue()

export const createIntlHeader = (id) => <FormattedMessage id={id} />

export const createColumn = ({ id, accessorKey, headerId, style }) => ({
  id,
  header: createIntlHeader(headerId),
  accessorKey,
  cell: defaultTableCell,
  ...(style ? { style } : {})
})
